import { render, staticRenderFns } from "./index.vue?vue&type=template&id=47ad3266&lang=html"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DelayHydration: require('/var/www/malayan/web/node_modules/nuxt-delay-hydration/dist/runtime/components/DelayHydration.vue').default})
